import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

/**
 * Auth Pages
 */
import LoginPage from "../../Pages/Login/LoginPage";

const ToLogin = () => {
    return <Navigate to="/login" replace={true} />;
};

const AuthNavigation = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} /> 
                <Route path="*" element={<ToLogin />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AuthNavigation;
